import React, { useId, useMemo, useCallback, useState, useEffect } from 'react';
import PostItem from './post-item';
import { PostItemSkeleton } from './post-item-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { EmptyScreen } from '@ui/components/moleculas';
import { ContextUserType } from '@ui/constants/context';
import { IMessageState } from '@ui/components/organisms/message/message.typings';

interface PostListSegmentProps {
  isLoading: boolean;
  initialLoading: boolean;
  messageState: IMessageState;
  userType: ContextUserType;
  isDynamicRoute?: boolean;
  emptyState: {
    title: string;
    message: string;
  };
  showEmptyScreen: boolean;
  nextPage: () => void;
}

const MemoizedPostItem = React.memo(PostItem);

const PostListSegment = (props: PostListSegmentProps) => {
  const id = useId();

  return (
    <>
      {!props.isLoading &&
        !props.initialLoading &&
        props.messageState.pinned_messages?.length > 0 && (
          <div className="mb-4">
            <div className="space-y-2 w-full">
              {props.messageState.pinned_messages?.map((post) => (
                <div key={post.id} className="min-w-[96%] flex-grow h-fit">
                  <MemoizedPostItem
                    key={post.id}
                    post={post}
                    userType={props.userType}
                    userId={props.messageState.user_id}
                    creator_id={post.creator_id}
                    communityPostRoute={props.messageState.communityPostRoute}
                    query={props.messageState.query}
                    contentType="post"
                    isDynamicRoute={props.isDynamicRoute}
                    communityDetails={props.messageState.community_details}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

      {(props.isLoading || props.initialLoading) && (
        <div className="p-3 md:p-0">
          <PostItemSkeleton />
        </div>
      )}

      <div className="pb-10">
        <InfiniteScroll
          className="space-y-2"
          dataLength={props.messageState.messages.length}
          next={props.nextPage}
          hasMore={props.messageState.hasMorePages}
          scrollableTarget={id}
          loader={
            <div className="my-2">
              <PostItemSkeleton />
            </div>
          }>
          {props.messageState.messages.map((post) => (
            <MemoizedPostItem
              key={post.id}
              post={post}
              userType={props.userType}
              userId={props.messageState.user_id}
              creator_id={post.creator_id}
              communityPostRoute={props.messageState.communityPostRoute}
              query={props.messageState.query}
              contentType="post"
              isDynamicRoute={props.isDynamicRoute}
              communityDetails={props.messageState.community_details}
            />
          ))}
        </InfiniteScroll>
      </div>

      {props.showEmptyScreen &&
        !props.initialLoading &&
        !props.messageState.pinned_messages?.length && (
          <EmptyScreen
            {...props.emptyState}
            className="mx-auto h-fit w-full max-w-sm bg-transparent lg:bg-transparent"
          />
        )}
    </>
  );
};

export default PostListSegment;
